module.exports = __webpack_public_path__ + "static/media/basket.295f2f1e.svg";